var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8107_43007)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 2.00033C4.68564 2.00033 1.99935 4.68662 1.99935 8.00033C1.99935 11.314 4.68564 14.0003 7.99935 14.0003C11.3131 14.0003 13.9993 11.314 13.9993 8.00033C13.9993 4.68662 11.3131 2.00033 7.99935 2.00033ZM0.666016 8.00033C0.666016 3.95024 3.94926 0.666992 7.99935 0.666992C12.0494 0.666992 15.3327 3.95024 15.3327 8.00033C15.3327 12.0504 12.0494 15.3337 7.99935 15.3337C3.94926 15.3337 0.666016 12.0504 0.666016 8.00033Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 6.00033C6.89478 6.00033 5.99935 6.89576 5.99935 8.00033C5.99935 9.10489 6.89478 10.0003 7.99935 10.0003C9.10392 10.0003 9.99935 9.10489 9.99935 8.00033C9.99935 6.89576 9.10392 6.00033 7.99935 6.00033ZM4.66602 8.00033C4.66602 6.15938 6.1584 4.66699 7.99935 4.66699C9.8403 4.66699 11.3327 6.15938 11.3327 8.00033C11.3327 9.84127 9.8403 11.3337 7.99935 11.3337C6.1584 11.3337 4.66602 9.84127 4.66602 8.00033Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81461 2.81559C3.07496 2.55524 3.49707 2.55524 3.75742 2.81559L6.58409 5.64225C6.84444 5.9026 6.84444 6.32471 6.58409 6.58506C6.32374 6.84541 5.90163 6.84541 5.64128 6.58506L2.81461 3.7584C2.55426 3.49805 2.55426 3.07594 2.81461 2.81559Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41461 9.41559C9.67496 9.15524 10.0971 9.15524 10.3574 9.41559L13.1841 12.2423C13.4444 12.5026 13.4444 12.9247 13.1841 13.1851C12.9237 13.4454 12.5016 13.4454 12.2413 13.1851L9.41461 10.3584C9.15426 10.098 9.15426 9.67594 9.41461 9.41559Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1841 2.81559C13.4444 3.07594 13.4444 3.49805 13.1841 3.7584L10.3574 6.58506C10.0971 6.84541 9.67496 6.84541 9.41461 6.58506C9.15426 6.32471 9.15426 5.9026 9.41461 5.64225L12.2413 2.81559C12.5016 2.55524 12.9237 2.55524 13.1841 2.81559Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7108 3.28892C12.9711 3.54927 12.9711 3.97138 12.7108 4.23173L10.3574 6.58506C10.0971 6.84541 9.67496 6.84541 9.41461 6.58506C9.15426 6.32471 9.15426 5.9026 9.41461 5.64225L11.7679 3.28892C12.0283 3.02857 12.4504 3.02857 12.7108 3.28892Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58409 9.41559C6.84444 9.67594 6.84444 10.098 6.58409 10.3584L3.75742 13.1851C3.49707 13.4454 3.07496 13.4454 2.81461 13.1851C2.55426 12.9247 2.55426 12.5026 2.81461 12.2423L5.64128 9.41559C5.90163 9.15524 6.32374 9.15524 6.58409 9.41559Z",
    fill: "#7E716D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8107_43007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSupportIcon);
export default __webpack_public_path__ + "static/media/menu-support-icon.8fd6f5fa0a0a6e8a71bef7c82d3678fe.svg";
export { ForwardRef as ReactComponent };